/* src/app/modules/invoice/invoice/invoice-dialog-project.component.css */
.pj-header-text {
  min-width: 0;
  padding-right: 32px;
}
/*# sourceMappingURL=invoice-dialog-project.component.css.map */
